import React from "react"

const Footer = () => {
	return(
	<div className="tc pa2">
		©Yash Patel 
	</div>
	)
}

export default Footer